import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { getZonaIvaCentro, modifyZonaIvaCentro, addZonaIvaCentro, removeZonaIvaCentro, getTiposZonasIva } from '../../actions/zona_iva_centro_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});


class CentroZonaIva extends React.Component {

    componentDidMount() {

        this.props.getZonaIvaCentro(this.props.centroid);

    };


    modifyZonaIvaCentro = (zonaiva) => {
        this.props.setSaveState(true);
        this.props.modifyZonaIvaCentro(zonaiva);
    };

    addZonaIvaCentro = (zonaiva) => {
        this.props.setSaveState(true);
        this.props.addZonaIvaCentro(zonaiva);
    };

    messageError = (error) => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkZonaIva = (zonaiva) => {

        if (this.props.tiposZonaIva.find(tzi => (tzi.descr === zonaiva.zonaIva) && (tzi.id !== zonaiva.iTipoZonaIva))) {
            this.messageError(`Ya existe un tipo de zona de iva ${zonaiva.zonaIva}`);
            return false;
        } else if (zonaiva.fIni < '1900-01-01T00:00:00') {
            this.messageError('Fecha de inicio inválida');
            return false;
        } else if (zonaiva.fEnd && zonaiva.fIni > zonaiva.fEnd) {
            this.messageError('Fecha de fin debe ser posterior a la de inicio');
            return false;
        }
        else return true;

    };

    editZonaIva = (zonaiva) => {

        this.props.openDialog('EditZonaIvaCentro', {
            zonaiva: zonaiva,
            tiposZonaIva: this.props.tiposZonaIva,
            okHandler: this.modifyZonaIvaCentro,
            checkZonaIva: this.checkZonaIva,
            centroid: this.props.centroid
        }, uuidv4());
    };

    newZonaIva = () => {

        this.props.openDialog('EditZonaIvaCentro', {
            zonaiva: {},
            tiposZonaIva: this.props.tiposZonaIva,
            okHandler: this.addZonaIvaCentro,
            checkZonaIva: this.checkZonaIva,
            centroid: this.props.centroid
        }, uuidv4());

    };

    removeZonaIva = zonaiva => {
        this.props.setSaveState(true);
        this.props.removeZonaIvaCentro(zonaiva);
    };

    render() {
        const { classes } = this.props;


        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Zonas IVA</Typography>
                {this.props.zonaIvaCentro && !this.props.isLoading ?
                    <NeuriteGrid
                        columns={[
                            { key: 'zonaIva', name: 'Zona Iva', tooltip: 'Zona a la que está asociado el tipo de IVA', editable: false, dragable: false, width: 110 },
                            { key: 'iva', name: 'Iva (%)', editable: false, dragable: false, type: 'float', width: 50, },
                            { key: 'fIni', name: 'Fecha Inicio', editable: false, dragable: false, type: 'date', width: 80, },
                            { key: 'fEnd', name: 'Fecha Fin', editable: false, dragable: false, type: 'date', width: 80, },
                        ]}
                        rows={this.props.zonaIvaCentro}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newZonaIva}
                        onEditClick={this.editZonaIva}
                        onDeleteClick={this.removeZonaIva}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

CentroZonaIva.propTypes = {
    //state
    zonaIvaCentro: PropTypes.array.isRequired,
    tiposZonaIva: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getZonaIvaCentro: PropTypes.func.isRequired,
    modifyZonaIvaCentro: PropTypes.func.isRequired,
    addZonaIvaCentro: PropTypes.func.isRequired,
    removeZonaIvaCentro: PropTypes.func.isRequired,
    getTiposZonasIva: PropTypes.func.isRequired,
    //parameters
    centroid: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        zonaIvaCentro: state.zonaIvaCentro.zonaIvaCentro,
        isLoading: state.zonasCentro.isLoading,
        tiposZonaIva: state.tiposZonaIva
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        getZonaIvaCentro,
        modifyZonaIvaCentro,
        addZonaIvaCentro,
        removeZonaIvaCentro,
        getTiposZonasIva,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CentroZonaIva));